var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPendingi = function SvgPendingi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    "data-name": "Group 10535"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.122 12c4-2.22 4.177-7.153 4.179-7.209a.77.77 0 0 0-.221-.558.78.78 0 0 0-.558-.233H6.539a.6.6 0 0 0-.116.03.7.7 0 0 0-.165.041 1 1 0 0 0-.116.078 1 1 0 0 0-.284.339 1 1 0 0 0-.031.154 1 1 0 0 0-.026.127v.04c0 .056.31 4.987 4.2 7.189-3.888 2.2-4.195 7.133-4.2 7.19v.039a1 1 0 0 0 .026.127.7.7 0 0 0 .032.155.7.7 0 0 0 .073.12.7.7 0 0 0 .087.127 1 1 0 0 0 .112.084.45.45 0 0 0 .276.123.7.7 0 0 0 .133.034h10.982a.79.79 0 0 0 .558-.232.77.77 0 0 0 .221-.559c-.002-.053-.184-4.986-4.179-7.206M7.466 5.542h9.186a6.77 6.77 0 0 1-4.6 5.649c-3.341-.983-4.313-4.141-4.586-5.649m.005 12.916c.284-1.507 1.274-4.674 4.586-5.649a6.71 6.71 0 0 1 4.6 5.649z",
    "data-name": "Path 10975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.379 16.912c-.136.075-.229 1.02-.229 1.02h7.8s-.094-.892-.229-.982c-1.025-.686-6.216-.655-7.342-.038",
    "data-name": "Path 10976"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.673 8.613a14 14 0 0 0-5.241 0c-.441.33 1.721 1.977 2.594 1.977s3.08-1.647 2.647-1.977",
    "data-name": "Path 10977"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPendingi);
export default ForwardRef;